import React from 'react';
import {StyleSheet, Dimensions, Text, StyleProp, ViewStyle} from 'react-native';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import Tooltip from './Tooltip';
import Styles from '../Styles';

const maxWidth = Dimensions.get('screen').width * 0.75;
type InfoIconProps = {
  infoMessage: string | string[];
  style: StyleProp<ViewStyle>;
};

const InfoIcon = (props: InfoIconProps) => (
  <Tooltip
    popover={<Text style={styles.tooltipText}>{props.infoMessage}</Text>}
    backgroundColor={Styles.darkColor}
    width={maxWidth}
  >
    <FontAwesome5Pro
      name="info-circle"
      color={Styles.primaryColor}
      size={Styles.Fonts.f2}
      light
      style={props.style}
    />
  </Tooltip>
);

const styles = StyleSheet.create({
  tooltipText: {
    color: Styles.white,
    fontSize: Styles.Fonts.f0,
  },
});

export default InfoIcon;
